import { render, staticRenderFns } from "./VatInvoiceHeader.vue?vue&type=template&id=7463b2f3&scoped=true&"
import script from "./VatInvoiceHeader.vue?vue&type=script&lang=js&"
export * from "./VatInvoiceHeader.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./VatInvoiceHeader.vue?vue&type=style&index=1&id=7463b2f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7463b2f3",
  null
  
)

export default component.exports